//MUI IMPORTS
import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import { Box, Button, Typography } from "@mui/material";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable from "material-react-table";

//MOMENT IMPORT
import moment from "moment";

import { getData } from "../../../../../services/library";
import DialogIIBB_Formulario from "../../../../referencias-tablas/clientes/datoscliente/impuestos/DialogIIBB_Formulario";
import { fetchPermisos } from "../../../../../services/services";
import * as api from "../../../../referencias-tablas/clientes/datoscliente/impuestos/api"
import InscripcionesExclusionesContainer from "../../../../referencias-tablas/clientes/datoscliente/impuestos/components/ui/InscripcionesExclusionesContainer";

function IIBBclienteEnvasado(props) {

  /* ----------------------------ESTADOS Y REFS-------------------------------  */ 
  const [porcentajesPercepcion, setPorcentajesPercepcion] = useState([{}]); //porcentajes de percepcion disponibles en caso de que el cliente sea responsable inscripto.
  const [dialogIIBB, setDialogIIBB] = useState(false);
  const [percepcionIva, setPercepcionIva] = useState();
  const [showFormIIBB, setShowFormIIBB] = useState(false);
  const [showFormIIBB2, setShowFormIIBB2] = useState(false);
  const [editarPercIva, setEditarPercIva] = useState(false);
  const [iibb, setiibb] = useState(null)
  // const [iibb, setiibb] = useState([
  //   { provincia: "Cargando...", percepcion: "Cargando..." },
  // ]);
  const [readOnly, setReadOnly] = useState(true);

  const [lastUpdate, setLastUpdate]=useState();
  const configConvenio = JSON.parse(props?.cliente?.config_convenio) || {}
  const [ciclo, setCiclo]=useState();
  const [permisos, setPermisos] = useState();
  const [showUpdates, setShowUpdates] = useState();

  const getPermisos = async() =>{
    const allPermisos = await fetchPermisos();
    const permisosModulo = allPermisos.filter(permiso=>permiso.modulo === "clientes_impuestos");
    setPermisos(permisosModulo)
    setShowUpdates(!!permisosModulo?.find(permiso=>permiso.funcion == "ver_actualizaciones"))
  }

  //SACAR ESTA FN DE ACA
  const getDatosCiclo = (configConvenio, setCiclo) => {
    if (configConvenio?.inscripcion_vence == 1) {
      api.getCicloFiscalActual(setCiclo);
    } else {
      setCiclo({
        id_ciclo: null,
      });
    }
  }

  /* ---------------------------- EFFECTS  ------------------------------------  */ 
  useEffect(() => {
    getData("/desplegables/porcentajesPercepcion", setPorcentajesPercepcion);
    getPermisos();
    getDatosCiclo(configConvenio, setCiclo)
  }, []);

  useEffect(() => {
    if (permisos && ciclo) {
      if (!!showUpdates){
        api.getAllInscripciones(props.cliente.cuit, ciclo?.id_ciclo, setiibb)
      } else {
        getData("/iibb_clientes/alliibb-sinperiodo/" + props.cliente.cuit, setiibb);
      }
    }
  }, [permisos, ciclo]);

  useEffect(() => {
    getData(
      `/iibb_clientes_logs/ultima_modificacion/${props.cliente.cuit}`,
      setLastUpdate
    );
    if (permisos && ciclo) {
      if (!!showUpdates){
        api.getAllInscripciones(props.cliente.cuit, ciclo?.id_ciclo, setiibb)
      } else {
        getData("/iibb_clientes/alliibb-sinperiodo/" + props.cliente.cuit, setiibb);
      }
    }
  }, [showFormIIBB]);

  
  /* ---------------------------- STYLING  ------------------------------------  */ 

  const columns = useMemo(
    () => [
      {
        // VA A FORMATEAR LAS FECHAS DE INICIO DE VIGENCIA DE LAS PERCEPCIONES POR PADRON. NO ASI DE LAS INGRESADAS A MANO
        accessorKey: "fecha_vigencia_desde",
        header: "Fecha Inicio Vigencia",
        Cell: ({ cell }) => {
          const fecha = cell.getValue();
          return moment(fecha).format("DD-MM-YYYY");
        },
      },
      {
        // VA A FORMATEAR LAS FECHAS DE INICIO DE VIGENCIA DE LAS PERCEPCIONES POR PADRON. NO ASI DE LAS INGRESADAS A MANO a
        accessorKey: "fecha_vigencia_hasta",
        header: "Fecha Fin Vigencia",
        Cell: ({ cell }) => {
          const fecha = cell.getValue();
          return fecha
            ? moment(fecha).format("DD-MM-YYYY")
            : "Fecha Indefinida";
        },
      },
      {
        accessorKey: "provincia",
        header: "Provincia",
      },
      {
        accessorKey: "percepcion",
        header: "Percepción",
      },
      {
        accessorKey: "porcentaje_excencion",
        header: "Exencion",
      },
      {
        accessorKey: "vto_excencion",
        header: "Vencimiento Exención",
        Cell: ({ cell }) => {
          const vto_ex = cell.getValue();
          return vto_ex ? moment(vto_ex).format("DD-MM-YYYY") : "";
        },
      },
    ],
    []
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: {
      pageSize: 5,
      pageIndex: 0,
    },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  /* ---------------------------- RENDER  ------------------------------------  */ 

  return (
    <div>
      <br />
      <Box boxShadow={3} pt={1} backgroundColor="#ebebeb">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          px={2}
        >
          <Typography variant="h6" sx={{ fontSize: 16 }} color="primary">
            Impuestos Provinciales (Ingresos Brutos)
          </Typography>
          {/* <Button
            variant="text"
            onClick={() => setShowFormIIBB(true)}
            disabled={props.soloLectura}
          >
            Editar
          </Button> */}
          { !showUpdates ? (
            <Button
              variant="text"
              onClick={() => setShowFormIIBB(true)}
              disabled={props.soloLectura}
            >
              Editar
            </Button>
          ) : (<Button
            variant="text"
            onClick={() => setShowFormIIBB2(true)}
            disabled={props.soloLectura}
          >
            Editar (C/ Ciclos)
          </Button>
          )}
        </Grid>
        <MaterialReactTable
          enableTopToolbar={false}
          muiSearchTextFieldProps={muiSearchTextFieldProps}
          // localization={MRT_Localization_ES}
          columns={columns}
          data={iibb||[{}]}
          enableColumnFilterModes={false}
          enableColumnOrdering={false}
          enableGrouping={false}
          enableEditing={false}
          initialState={initialState}
          positionActionsColumn="last"
          enableHiding={false}
          enableExpandAll={false}
          enableColumnActions={false}
          enableColumnFilters={false} 
          enableDensityToggle={false}
          localization={{
            ...MRT_Localization_ES,
            noRecordsToDisplay: !configConvenio ? "Es necesario registrar la sit. iibb del cliente.." : "No hay inscripciones registradas para este cliente.",
          }}
          renderBottomToolbarCustomActions={() =>
            lastUpdate ? (
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{ padding: "8px" }}
              >
                Última actualización:{" "}
                {moment(lastUpdate.created_at).format("DD-MM-YYYY")} || Usuario:{" "}
                {lastUpdate.usuario}
              </Typography>
            ) : (
              <></>
            )
            // <Typography variant="caption" color="textSecondary" sx={{ padding: '8px' }}>
            // </Typography>
          }
        />
      </Box>
      <br />
      <br />
      {showFormIIBB && (
        <DialogIIBB_Formulario
          open={showFormIIBB}
          setOpen={setShowFormIIBB}
          cliente={props.cliente}
        />
      )}
      {showFormIIBB2 && (
        <InscripcionesExclusionesContainer
          open={showFormIIBB2}
          setOpen={setShowFormIIBB2}
          cliente={props.cliente}
          cicloFiscalActual={ciclo}
        />
      )}
    </div>
  );
}

export default IIBBclienteEnvasado;
